import { render, staticRenderFns } from "./togglePill.vue?vue&type=template&id=5b36ea02&scoped=true"
import script from "./togglePill.vue?vue&type=script&lang=js"
export * from "./togglePill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b36ea02",
  null
  
)

export default component.exports